import * as React from 'react';
import { InvoiceStatus } from '../../../@types';
import { getStatusColor } from '../../invoice/Status/status';

interface BadgeProps {
  label: string;
  color: 'cancelled' | 'paid' | 'pending'  | 'draft'  | 'refunded' | 'overdue' | 'secondary';
}

const Badge: React.FC<BadgeProps> = (props) => {
  const getColor = React.useCallback((): string => {
    switch (props.color) {
      case 'cancelled':
        return '#FB0303';
      case 'paid':
        return '#088306';
      case 'pending':
        return '#FF6702';
      case 'draft':
        return '#4E4E4E';
        case 'refunded':
          return '#044E97';
          case 'overdue':
            return '#FB0303';
            case 'secondary':
              return '#0a0707';
      default:
        return props.color;
    }
  }, [props.color]);

  return (
    <span className={`bg-opacity-20 px-2 py-1 rounded-[4px] bg-[${getColor()}] text-[${getColor()}]`}>
      {props.label}
    </span>
  );
};

export { Badge };
